<template lang="pug">
    section.payment-method-form
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                el-button.delete-button(
                    v-if="$route.params.id != 'new' && checkRestrictions(['settings', 'ex:shop'], 'update')"
                    circle
                    type="danger"
                    icon="el-icon-fa-trash-alt far"
                    @click="deleteItem"
                )
                el-button(
                    circle icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                )
                el-button(
                    circle v-if="! loading && checkRestrictions(['settings', 'ex:shop'], 'update')"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :disabled="isDisabledSubmit && ! savingAndClose"
                    :loading="savingAndClose"
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle v-if="! loading && checkRestrictions(['settings', 'ex:shop'], 'update')"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :disabled="isDisabledSubmit && ! saving"
                    :loading="saving"
                    @click="submit"
                )
        el-card(shadow="always" v-loading="loading")
            el-row
                el-form.form(v-if="form" ref="form" :rules="rules" :model="form" @submit.prevent="submit")
                    el-row(:gutter="40")
                        el-col(:lg="form.service === 'paypal' ? 8 : 16")
                            el-form-item(:label="$t('payment method name')" prop="name")
                                el-input(
                                    :value="form.name"
                                    maxlength="255"
                                    name="name"
                                    prop="name"
                                    @input="value => updateForm({ path: 'name', value })"
                                )
                        el-col(v-if="form.service === 'paypal'" :lg="8")
                            el-form-item(:label="$t('environment')" prop="environment")
                                el-select(
                                    :value="form.environment"
                                    @change="value => updateForm({ path: 'environment', value })"
                                )
                                    el-option(
                                        key="production"
                                        :label="$t('production')"
                                        value="production"
                                    )
                                    el-option(
                                        key="sandbox"
                                        :label="$t('sandbox')"
                                        value="sandbox"
                                    )
                        el-col(:lg="8")
                            el-form-item(:label="$t('payment service')" prop="service")
                                //- el-select(:value="form.service" @change="value => updateForm({ path: 'service', value })")
                                el-select(v-model="service")
                                    el-option(
                                        v-for="item in services.shop"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    )
                                    el-option-group(
                                        v-if="enabledExtensions.includes('shop:point-of-sale')"
                                        key="pos"
                                        :label="$t('Point of Sale')"
                                    )
                                        el-option(
                                            v-for="item in services.pos"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        )
                    el-row(:gutter="40")
                        el-col(:lg="8")
                            el-form-item(label=" ")
                                el-switch(
                                    :value="form.active"
                                    :active-text="$t('Active')"
                                    @change="value => updateForm({ path: 'active', value })"
                                )

                    el-form-item(:label="$t('Description')" prop="description")
                        el-input(
                            :value="form.description"
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 40 }"
                            @input="value => updateForm({ path: 'description', value })"
                        )

                    el-form-item(:label="$t('Additional Info')" prop="additional_info")
                        el-input(
                            :value="form.additional_info"
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 40 }"
                            @input="value => updateForm({ path: 'additional_info', value })"
                        )

                    transition(name="slide-decent-vertical" mode="out-in")
                        .custom-settings(v-if="form.service === 'custom'")
                            .flex-row
                                el-form-item(prop="digital")
                                    el-switch(
                                        :value="form.digital"
                                        active-color="$--color-primary"
                                        inactive-color="$--color-primary"
                                        :active-text="$t('Digital Payment')"
                                        @input="value => updateForm({ path: 'digital', value: !!value })"
                                    )
                                el-form-item(prop="instant")
                                    el-switch(
                                        :value="form.instant"
                                        active-color="$--color-primary"
                                        inactive-color="$--color-primary"
                                        :active-text="$t('Instant Payment')"
                                        @input="value => updateForm({ path: 'instant', value: !!value })"
                                    )

                    transition(name="slide-decent-vertical" mode="out-in")
                        .rules(v-if="form.paymentMethodRules && form.paymentMethodRules.length")
                            p.mb-2.mt-8 {{ $t('rules ({count})', { count: form.paymentMethodRules.length }) }}

                            el-alert.mb-2(
                                type="info"
                                :title="$t('All rules must be met to use this payment method.')"
                                :closable="false"
                                show-icon
                                effect="dark"
                            )

                            transition-group(name="slide-decent-vertical")
                                .panel(
                                    v-for="(rule, index) in form.paymentMethodRules"
                                    :key="rule.id || index"
                                    :class="{ odd: index % 2 }"
                                )
                                    .flex-row
                                        //- el-form-item.custom-label(
                                        //-     :label="$t('rule:name')"
                                        //-     :prop="`paymentMethodRules.${index}.name`"
                                        //- )
                                        //-     el-input(
                                        //-         :value="rule.name"
                                        //-         maxlength="255"
                                        //-         @input="value => updateForm({ path: `paymentMethodRules.${index}.name`, value })"
                                        //-     )
                                        el-form-item.custom-label.rule-type(
                                            :label="$t('Type')"
                                            :prop="`paymentMethodRules.${index}.type`"
                                        )
                                            el-select(
                                                placeholder=""
                                                :value="rule.type"
                                                autocomplete="no-fill"
                                                @change="value => updateRule('type', index, value)"
                                            )
                                                el-option-group(key="regular")
                                                    el-option(
                                                        key="price"
                                                        value="price"
                                                        :label="$t('Shopping cart value')"
                                                    )
                                                    //- el-option(
                                                    //-     key="points"
                                                    //-     value="points"
                                                    //-     :label="$t('Points')"
                                                    //- )
                                                    //- el-option(
                                                    //-     key="weight"
                                                    //-     value="weight"
                                                    //-     :label="$t('Weight')"
                                                    //-     disabled
                                                    //- )
                                                    //- el-option(
                                                    //-     key="quantity"
                                                    //-     value="quantity"
                                                    //-     :label="$t('Quantity')"
                                                    //-     disabled
                                                    //- )
                                                el-option-group(
                                                    key="countries"
                                                    :label="$t('Countries')"
                                                )
                                                    el-option(
                                                        key="countries:include"
                                                        value="countries:include"
                                                        :label="$t('Apply to selected countries')"
                                                    )
                                                    el-option(
                                                        key="countries:exclude"
                                                        value="countries:exclude"
                                                        :label="$t('Exclude selected countries')"
                                                    )
                                                el-option-group(
                                                    key="member-tags"
                                                    :label="$t('Customer tags')"
                                                )
                                                    el-option(
                                                        key="member-tags:include"
                                                        value="member-tags:include"
                                                        :label="$t('Apply to selected customer tags')"
                                                    )
                                                    el-option(
                                                        key="member-tags:exclude"
                                                        value="member-tags:exclude"
                                                        :label="$t('Exclude selected customer tags')"
                                                    )
                                                el-option-group(
                                                    key="customer-groups"
                                                    :label="$t('Customer groups')"
                                                )
                                                    el-option(
                                                        key="customer-groups:include"
                                                        value="customer-groups:include"
                                                        :label="$t('Apply to selected customer groups')"
                                                    )
                                                    el-option(
                                                        key="customer-groups:exclude"
                                                        value="customer-groups:exclude"
                                                        :label="$t('Exclude selected customer groups')"
                                                    )
                                        transition(name="fade" mode="out-in")
                                            .price-fields.flex-row.grow(v-if="rule.type === 'price'" key="price")
                                                el-form-item.custom-label.rule-price-fields(
                                                    :label="$t('min.')"
                                                    :prop="`paymentMethodRules.${index}.min_sum`"
                                                )
                                                    el-input-number(
                                                        :value="rule.min_sum == null ? undefined : rule.min_sum"
                                                        type="number"
                                                        :step="0.01"
                                                        :min="0"
                                                        :step-strictly="true"
                                                        controls-position="right"
                                                        placeholder="0"
                                                        @input.native="e => updateRule('min_sum', index, e.target.value)"
                                                        @change="value => updateRule('min_sum', index, value)"
                                                    )
                                                el-form-item.custom-label.rule-price-fields(
                                                    :label="$t('max.')"
                                                    :prop="`paymentMethodRules.${index}.max_sum`"
                                                )
                                                    el-input-number(
                                                        :value="rule.max_sum == null ? undefined : rule.max_sum"
                                                        type="number"
                                                        :step="0.01"
                                                        :min="0"
                                                        :step-strictly="true"
                                                        controls-position="right"
                                                        placeholder="∞"
                                                        @input.native="e => updateRule('max_sum', index, e.target.value)"
                                                        @change="value => updateRule('max_sum', index, value)"
                                                    )
                                            //- .points-fields.flex-row.grow(v-else-if="rule.type === 'points'" key="points")
                                            //-     el-form-item.custom-label.rule-points-fields(
                                            //-         :label="$t('min.')"
                                            //-         :prop="`paymentMethodRules.${index}.min_points`"
                                            //-     )
                                            //-         el-input-number(
                                            //-             :value="rule.min_points == null ? undefined : rule.min_points"
                                            //-             type="number"
                                            //-             :step="1"
                                            //-             :min="0"
                                            //-             :step-strictly="true"
                                            //-             controls-position="right"
                                            //-             placeholder="0"
                                            //-             @input.native="e => updateRule('min_points', index, parseFloat(e.target.value))"
                                            //-             @change="value => updateRule('min_points', index, value)"
                                            //-         )
                                            //-     el-form-item.custom-label.rule-points-fields(
                                            //-         :label="$t('max.')"
                                            //-         :prop="`paymentMethodRules.${index}.max_points`"
                                            //-     )
                                            //-         el-input-number(
                                            //-             :value="rule.max_points == null ? undefined : rule.max_points"
                                            //-             type="number"
                                            //-             :step="1"
                                            //-             :min="0"
                                            //-             :step-strictly="true"
                                            //-             controls-position="right"
                                            //-             placeholder="∞"
                                            //-             @input.native="e => updateRule('max_points', index, parseFloat(e.target.value))"
                                            //-             @change="value => updateRule('max_points', index, value)"
                                            //-         )
                                            .countries-fields.flex-row.grow(
                                                v-else-if="['countries:include', 'countries:exclude'].includes(rule.type)"
                                                key="countries"
                                            )
                                                el-form-item.custom-label.grow(
                                                    :label="$t('Countries')"
                                                    :prop="`paymentMethodRules.${index}.countries`"
                                                )
                                                    el-select(
                                                        placeholder=""
                                                        :value="rule.countries"
                                                        multiple
                                                        clearable
                                                        filterable
                                                        value-key="id"
                                                        autocomplete="no-fill"
                                                        @change="value => updateForm({ path: `paymentMethodRules.${index}.countries`, value })"
                                                    )
                                                        el-option(
                                                            v-for="(label, value) in countries"
                                                            :key="value"
                                                            :label="label"
                                                            :value="value"
                                                        )
                                            .member-tags-fields.flex-row.grow(
                                                v-else-if="['member-tags:include', 'member-tags:exclude'].includes(rule.type)"
                                                key="member-tags"
                                            )
                                                el-form-item.custom-label.grow(
                                                    :label="$t('Customer tags')"
                                                    :prop="`paymentMethodRules.${index}.memberTags`"
                                                )
                                                    el-select(
                                                        placeholder=""
                                                        :value="rule.memberTags"
                                                        multiple
                                                        clearable
                                                        filterable
                                                        value-key="id"
                                                        autocomplete="no-fill"
                                                        @change="value => updateForm({ path: `paymentMethodRules.${index}.memberTags`, value })"
                                                    )
                                                        el-option(
                                                            v-for="tag in options.memberTag.items"
                                                            :key="tag.id"
                                                            :label="tag.name"
                                                            :value="tag"
                                                        )
                                            .customer-groups-fields.flex-row.grow(
                                                v-else-if="['customer-groups:include', 'customer-groups:exclude'].includes(rule.type)"
                                                key="customer-groups"
                                            )
                                                el-form-item.custom-label.grow(
                                                    :label="$t('Customer groups')"
                                                    :prop="`paymentMethodRules.${index}.customerGroups`"
                                                )
                                                    el-select(
                                                        placeholder=""
                                                        :value="rule.customerGroups"
                                                        multiple
                                                        clearable
                                                        filterable
                                                        value-key="id"
                                                        autocomplete="no-fill"
                                                        @change="value => updateForm({ path: `paymentMethodRules.${index}.customerGroups`, value })"
                                                    )
                                                        el-option(
                                                            v-for="group in options.customerGroup.items"
                                                            :key="group.id"
                                                            :label="group.name"
                                                            :value="group"
                                                        )

                                        el-form-item.custom-label(label=" ")
                                            el-button(
                                                type="danger"
                                                circle
                                                icon="el-icon-fa-trash-alt far"
                                                size="mini"
                                                @click="removeRule(index)"
                                            )
                        hr(v-else)

                    el-button.mt-2(
                        type="primary"
                        icon="el-icon-fa-plus fas"
                        :disabled="isDisabledRuleButton"
                        @click.stop.prevent="addPaymentRule"
                    ) {{ $t('add rule') }}

        .form-buttons
            el-button(
                round v-if="! loading && checkRestrictions(['settings', 'ex:shop'], 'update')"
                icon="el-icon-fa-times fas"
                :disabled="isDisabledSubmit"
                @click="leave"
            ) {{ $t('Dismiss') }}
            el-button(
                round v-if="! loading && checkRestrictions(['settings', 'ex:shop'], 'update')"
                type="primary"
                icon="el-icon-fa-check fas"
                :loading="savingAndClose"
                :disabled="isDisabledSubmit && ! savingAndClose"
                @click="submit($event, listRoute)"
            ) {{ $t('Save and close') }}
            el-button(
                round v-if="! loading && id && checkRestrictions(['settings', 'ex:shop'], 'update')"
                type="success"
                icon="el-icon-fa-save fas"
                :loading="saving"
                :disabled="isDisabledSubmit && ! saving"
                @click="submit"
            ) {{ $t('Save') }}
</template>

<i18n>
    {
        "en": {
            "rule:name": "name",
            "countries ({count})": "countries ({count})",
            "rules ({count})": "rules ({count})",
            "member tags ({count})": "member tags ({count})",
            "customer groups ({count})": "customer groups ({count})"
        },
        "de": {
            "rule:name": "Bezeichnung",
            "all": "alle",
            "Price": "Preis",
            "Prices": "Preise",
            "Shopping cart value": "Bestellwert",
            "Points": "Punkte",
            "Weight": "Gewicht",
            "Quantity": "Artikelmenge",
            "Payment method": "Zahlungsart",
            "payment service": "Zahlungsdienst",
            "Payment method saved successfully!": "Zahlungsart erfolgreich gespeichert!",
            "Payment method could not be saved.": "Zahlungsart konnte nicht gespeichert werden.",
            "payment method name": "Name der Zahlungsart",
            "Description": "Beschreibung",
            "Additional Info": "Zusätzliche Informationen",
            "Payment method deleted successfully!": "Zahlungsart erfolgreich gelöscht!",
            "Active": "Aktiv",
            "rule name": "Regelbezeichnung",
            "All rules must be met to use this payment method.": "Alle Regeln müssen erfüllt sein, um diese Zahlungsart zu nutzen.",
            "remove rule": "Regel entfernen",
            "add rule": "Regel hinzufügen",
            "add": "hinzufügen",
            "Points minimum": "Punkte-Minimum",
            "Points maximum": "Punkte-Maximum",
            "sum minimum": "Bestellwert-Minimum",
            "sum maximum": "Bestellwert-Maximum",
            "Countries": "Länder",
            "Countries rule": "Länder-Regel",
            "Customer tags": "Kunden-Tags",
            "Customer tags rule": "Kunden-Tags-Regel",
            "Apply to selected customer tags": "Auf ausgewählte Kunden-Tags anwenden",
            "Exclude selected customer tags": "Ausgewählte Kunden-Tags ausschließen",
            "Customer groups": "Kundengruppen",
            "Customer groups rule": "Kundengruppen-Regel",
            "Apply to selected customer groups": "Auf ausgewählte Kundengruppen anwenden",
            "Exclude selected customer groups": "Ausgewählte Kundengruppen ausschließen",
            "If selected, this payment method can only be used by the selected customer groups.": "Bei Auswahl kann diese Zahlungsart nur von den ausgewählten Kundengruppen genutzt werden.",
            "no countries assigned": "Keine Länder zugewiesen.",
            "Apply to selected countries": "Auf ausgewählte Länder anwenden",
            "Exclude selected countries": "Ausgewählte Länder ausschließen",
            "If no selection is made, this rule is ignored.": "Wenn keine Auswahl getroffen wird, wird diese Regel ignoriert.",
            "If selected, this payment method can only be used by customers whose payment address is in one of the selected countries.": "Bei Auswahl kann diese Zahlungsart nur von Kunden genutzt werden, deren Rechnungsadresse in einem der ausgewählten Länder liegt.",
            "no member tags assigned": "Keine Mitglieder-Tags zugewiesen.",
            "If selected, this payment method can only be used by tagged customers. The customer must have at least one of the following tags.": "Bei Auswahl kann diese Zahlungsart nur von getaggten Kunden genutzt werden. Der Kunde muss dabei mindestens eines der folgenden Tags haben.",
            "no customer groups assigned": "Keine Kundengruppen zugewiesen.",
            "enable order value": "Bestellwert aktivieren",
            "countries ({count})": "Länder ({count})",
            "rules ({count})": "Regeln ({count})",
            "member tags ({count})": "Mitglieder-Tags ({count})",
            "customer groups ({count})": "Kundengruppen ({count})",
            "Warning": "Achtung",
            "This payment method is not yet implemented. Please choose another one.": "Diese Zahlungsart ist noch nicht implementiert. Bitte wählen Sie eine andere.",
            "example:": "Beispiel:",
            "more / user defined" : "Weitere / Benutzerdefiniert",
            "No payment" : "Keine Zahlung",
            "In advance": "Vorkasse",
            "On account": "Rechnung",
            "Direct debit": "Lastschrift",
            "Point of Sale": "Kasse",
            "Debit card": "EC-Karte",
            "Credit card": "Kredit-Karte",
            "Cash": "Barzahlung",
            "Digital Payment": "Digitale Zahlung",
            "Instant Payment": "Sofortige Zahlung",
            "environment": "Umgebung",
            "production": "Production",
            "sandbox": "Sandbox"
        }
    }
    </i18n>

<script>
import _ from 'lodash'
import { checkRestrictions } from '@/helpers'
import store from '@/store';
import pinia from '@/pinia'
import { useSetupStore, useShopPaymentStore } from '@/stores'

import Tabs from '@/components/Tabs';

import countries from 'i18n-iso-countries'
import de from 'i18n-iso-countries/langs/de.json'
countries.registerLocale(de)

import router from '@/router';
import { country } from '@/filters'

export default {
    name: "PaymentMethodForm",
    data() {
        return {
            listRoute: { name: 'payment-methods' },
            loading: false,
            saving: false,
            savingAndClose: false,
            newRuleName: '',
            services: {
                shop: [
                    { id: 'paypal', name: 'PayPal' },
                    { id: 'stripe', name: 'Stripe' },
                    { id: 'advance-payment', name: this.$t('In advance') },
                    { id: 'on-account', name: this.$t('On account') },
                    { id: 'debit', name: this.$t('Direct debit') },
                    // { id: 'card', name: `${this.$t('Debit card')} / ${this.$t('Credit card')}` },
                    // { id: 'cash', name: this.$t('Cash') },
                    { id: 'custom', name: this.$t('more / user defined') },
                    // { id: 'none', name: this.$t('No payment') },
                ],
                pos: [
                    { id: 'card', name: `${this.$t('Debit card')} / ${this.$t('Credit card')}` },
                    { id: 'cash', name: this.$t('Cash') },
                ]
            }
        }
    },
    components: {
        Tabs,
    },
    computed: {
        isDisabledRuleButton() {
            // return !this.newRuleName != ''
            return false
        },
        tabs() {
            const id = this.$route.params.id;
            let tabs = [
                {
                    name: this.$t('Payment method'),
                    path: `/payment-method/${id}`,
                    icon: {
                        name: 'credit-card',
                        group: 'fas'
                    }
                },
            ];

            // if (this.form.price_type !== 'free') {
            //     tabs.push({
            //         name: this.$t('Prices'),
            //         path: `/payment-method/${id}/prices`,
            //         icon: {
            //             name: 'euro-sign',
            //             group: 'fas'
            //         }
            //     })
            // }

            return tabs;
        },
        id() {
            return _.get(this.form, 'id', false);
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.deleting;
        },
        countries() {
            return countries.getNames('de')
        },
        template() {
            return _.get(this.activeCms, 'config.template')
        },
        activeShop() {
            return this.activeCms.shop;
        },
        // services() {
        //     let services = {
        //     };
        //     // if (this.enabledExtensions.includes('shop:point-of-sale')) {
        //     //
        //     // }
        // },
        service: {
            get() {
                return this.form.service
            },
            set(value) {
                if (!this.id) {
                    switch (value) {
                        case 'paypal':
                        case 'stripe':
                            this.updateForm({ path: 'digital', value: true })
                            this.updateForm({ path: 'instant', value: true })
                            this.updateForm({ path: 'shop_flag', value: true })
                            this.updateForm({ path: 'point_of_sale_flag', value: false })
                            if (value === 'paypal') this.updateForm({ path: 'environment', value: 'sandbox' })
                            // if (this.form.name === '') {
                            //     if (value === 'paypal') this.updateForm({ path: 'name', value: 'PayPal' })
                            //     if (value === 'stripe') this.updateForm({ path: 'name', value: 'Stripe' })
                            // }
                            break;

                        case 'on-account':
                        case 'advance-payment':
                            this.updateForm({ path: 'digital', value: true })
                            this.updateForm({ path: 'instant', value: false })
                            this.updateForm({ path: 'shop_flag', value: true })
                            this.updateForm({ path: 'point_of_sale_flag', value: false })
                            break;

                        case 'debit':
                            this.updateForm({ path: 'digital', value: true })
                            this.updateForm({ path: 'instant', value: true })
                            this.updateForm({ path: 'shop_flag', value: true })
                            this.updateForm({ path: 'point_of_sale_flag', value: false })
                            break;

                        case 'card':
                        case 'cash':
                            this.updateForm({ path: 'digital', value: value === 'card' })
                            this.updateForm({ path: 'instant', value: true })
                            this.updateForm({ path: 'shop_flag', value: false })
                            this.updateForm({ path: 'point_of_sale_flag', value: true })
                            break;

                        case 'custom':
                            this.updateForm({ path: 'digital', value: true })
                            this.updateForm({ path: 'instant', value: true })
                            this.updateForm({ path: 'shop_flag', value: true })
                            this.updateForm({ path: 'point_of_sale_flag', value: false })
                            break;

                        default:
                            this.$notify.warning({
                                title: this.$t('Warning'),
                                message: this.$t('This payment method is not yet implemented. Please choose another one.'),
                                iconClass: 'fas el-icon-fa-info-circle',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            break;
                    }

                    if (value !== 'paypal') this.updateForm({ path: 'environment', value: 'production' })
                }

                this.updateForm({ path: 'service', value })
            }
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        paymentStore() {
            return useShopPaymentStore();
        },
        form() {
            return this.paymentStore.form;
        },
        options() {
            return this.paymentStore.options;
        },
        rules() {
            return this.paymentStore.rules;
        },
    },
    methods: {
        updateRule(path, index, value) {
            if (value === '') value = undefined

            // this.updateFormIndex({ path: `paymentMethodRules.${index}.${path}`, value, index })
            this.updateForm({ path: `paymentMethodRules.${index}.${path}`, value })
            this.updateRuleValidation({ path, index, value })

            switch (path) {
                case 'type':
                    if (value === 'price' && (this.form.paymentMethodRules[index].min_sum || this.form.paymentMethodRules[index].max_sum)) {
                        setTimeout(() => {
                            this.$refs.form.validateField(`paymentMethodRules.${index}.min_sum`)
                            this.$refs.form.validateField(`paymentMethodRules.${index}.max_sum`)
                        }, 600)
                    }
                    // else if (value === 'points' && (this.form.paymentMethodRules[index].min_points || this.form.paymentMethodRules[index].max_points)) {
                    //     setTimeout(() => {
                    //         this.$refs.form.validateField(`paymentMethodRules.${index}.min_points`)
                    //         this.$refs.form.validateField(`paymentMethodRules.${index}.max_points`)
                    //     }, 600)
                    // }
                    break;

                case 'min_sum':
                case 'max_sum':
                    this.$refs.form.validateField(`paymentMethodRules.${index}.min_sum`)
                    this.$refs.form.validateField(`paymentMethodRules.${index}.max_sum`)
                    break;

                // case 'min_points':
                // case 'max_points':
                //     this.$refs.form.validateField(`paymentMethodRules.${index}.min_points`)
                //     this.$refs.form.validateField(`paymentMethodRules.${index}.max_points`)
                //     break;
            }

        },
        addPaymentRule() {
            this.addRule(this.newRuleName)
            this.newRuleName = ''
        },
        deleteItem() {
            this.loading = true
            this.deletePaymentMethod(this.$route.params.id).then(() => {
                router.push(this.listRoute);

                this.$notify.success({
                    title: this.$t('Payment method deleted successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            })
        },
        countryMethod(i) {
            const language = 'de'
            return country(i, language)
        },
        initialize() {
            this.loading = true

            let dependencies = [];

            if (this.$route.params.id === 'new') {
                this.resetForm();
            } else if (!isNaN(this.$route.params.id)) {
                dependencies.push(this.fetchPaymentMethod(this.$route.params.id).then(() => {
                    this.form.paymentMethodRules.forEach((rule, index) => {
                        switch (rule.type) {
                            case 'price':
                                this.updateRuleValidation({ path: 'min_sum', index, value: rule.min_sum })
                                this.updateRuleValidation({ path: 'max_sum', index, value: rule.max_sum })
                                break;
                            // case 'points':
                            //     this.updateRuleValidation({ path: 'min_points', index, value: rule.min_points })
                            //     this.updateRuleValidation({ path: 'max_points', index, value: rule.max_points })
                            //     break;
                        }
                    })
                }))
            }

            dependencies.push(this.fetchTagOptions(this.activeCms.id))
            dependencies.push(this.fetchCustomerGroupOptions(this.activeShop.id))

            const fetchDependencies = () => Promise.all(dependencies);

            const handleDependencyError = err => {
                const { graphQLErrors } = err

                let code = 501;
                let message = 'An error occurred!';

                if (graphQLErrors) {
                    code = _.get(graphQLErrors, '0.code') || code;
                    message = _.get(graphQLErrors, '0.message') || message;
                }

                let notify = true;
                switch (code) {
                    case 401:
                        notify = false;
                        this.error = { code, message: 'You are not authorized' };
                        break;
                    case 403:
                        notify = false;
                        this.error = { code, message: 'You are not allowed to be here' };
                        break;
                    // case 404:
                    //     break;
                    default:
                        this.error = true;
                        break;
                }

                if (notify) {
                    this.$notify.error({
                        title: this.$t(message),
                        message: this.$t('Dependencies could not be fetched.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }

                this.loading = false;

                console.error(err);
            }

            fetchDependencies()
                .then(() => {
                    // if (this.$route.params.id === 'new') {
                    //     this.resetForm();
                    // } else if (!isNaN(this.$route.params.id)) {
                    //     this.fetch();
                    // }
                })
                .catch(handleDependencyError)
                .finally(() => {
                    this.loading = false;
                });

        },
        // fetch() {
        //     this.loading = true;
        //     return this.fetchPaymentMethod(this.$route.params.id)
        //         .catch(err => {
        //             console.error(err);
        //         }).finally(() => {
        //             this.loading = false;
        //         });
        // },
        update(path, value) {
            this.updateForm({ path, value })
        },
        submit(event, redirect = false) {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (redirect) this.savingAndClose = true;
                    else this.saving = true;

                    let save = this.createPaymentMethod;
                    if (this.id) save = this.updatePaymentMethod;

                    this.loading = true

                    const payload = _.cloneDeep(this.form);

                    const shop = this.activeShop;
                    payload.shop = { id: shop.id };
                    // Multistore: methods belong to the store that is selected, not to
                    // whichever store of this shop the backend happens to see first.
                    payload.cms = { id: this.activeCms.id };
                    for (const item of payload.paymentMethodRules) {
                        // item.min_points = parseFloat(item.min_points)
                        // item.max_points = parseFloat(item.max_points)
                        item.min_sum = parseFloat(item.min_sum)
                        item.max_sum = parseFloat(item.max_sum)
                    }

                    save(payload)
                        .then(paymentMethod => {
                            this.$notify.success({
                                title: this.$t('Payment method saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            // NOTE: wird bereits durch savePaymentMethod mutation erledigt
                            // else this.fetch();

                            if (redirect) {
                                router.push(redirect);
                            } else {
                                if (this.$route.params.id === 'new') {
                                    const route = router.currentRoute
                                    route.params.id = paymentMethod.id
                                    router.replace(route)
                                }
                            }
                        })
                        .catch(err => {
                            console.error(err);

                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Payment method could not be saved.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .finally(() => {
                            this.loading = false;

                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;
                        });
                }
                else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        leave() {
            router.push(this.listRoute);
        },
        checkRestrictions,
        activateTab(item) {
            return useSetupStore().activateTab(item);
        },
        fetchPaymentMethod(id) {
            return this.paymentStore.fetchPaymentMethod(id);
        },
        deletePaymentMethod(id) {
            return this.paymentStore.deletePaymentMethod(id);
        },
        fetchCustomerGroupOptions(cmsID) {
            return this.paymentStore.fetchCustomerGroupOptions(cmsID);
        },
        fetchTagOptions(cmsID) {
            return this.paymentStore.fetchTagOptions(cmsID);
        },
        createPaymentMethod(payload) {
            return this.paymentStore.createPaymentMethod(payload);
        },
        updatePaymentMethod(payload) {
            return this.paymentStore.updatePaymentMethod(payload);
        },
        resetForm() {
            this.paymentStore.resetForm();
        },
        updateForm(payload) {
            this.paymentStore.updateForm(payload);
        },
        addRule(name) {
            this.paymentStore.addRule(name);
        },
        removeRule(index) {
            this.paymentStore.removeRule(index);
        },
        updateRuleValidation(payload) {
            this.paymentStore.updateRuleValidation(payload);
        },
    },
    beforeRouteEnter(to, from, next) {
        let shop = _.get(useSetupStore(pinia), 'activeCms.shop');
        if (!shop) {
            next({ name: 'payment-methods' });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        // setTimeout(() => {
        // }, 300);

        const paymentStore = useShopPaymentStore(pinia);
        paymentStore.resetForm();
        paymentStore.resetRules();
    },
    mounted() {
        this.initialize();
    }
}
</script>

<style lang="sass" scoped>
.payment-method-form::v-deep
    // .black
    //    .el-form-item__label
    //        color: black
    // .el-collapse-item,
    // .el-collapse-item__wrap
    //     background: #F8F8F8
    // .el-collapse-item__wrap
    //     padding: 20px
    //     padding-top: 0

    // .ml10
    //     margin-left: 10px
    // .delete-button
    //     margin-bottom: 6px

    // .collapse0
    //     .el-collapse-item__header
    //         background: #F0F0F0
    //         padding-left: 20px
    //         padding-right: 10px
    // .collapse1
    //     .el-collapse-item__header
    //         background: #E8E8E8
    //         padding-left: 20px
    //         padding-right: 10px
    // .borders
    //     border-left: 1px solid gray
    //     border-right: 1px solid gray
    // .ml10
    //     margin-left: 10px
    // .mt20
    //     margin-top: 20px
    // .mt10
    //     margin-top: 10px
    // td.center
    //     text-align: center
    //     width: 70px
    // .top-buttons
    //     display: flex
    //     justify-content: flex-end
    //     padding-bottom: 4px

    .form
        input
            width: 50px
        .el-select
            width: 100%
            .el-input__inner
                width: 100%
        .el-form-item
            .el-input__inner
                width: 100%
        .el-form-item.custom-label
            margin-bottom: 6px
            .el-form-item__label
                color: black
    // .mb
    //     margin-bottom: 12px
    // .mb0
    //     margin-bottom: 12px
    // .striped
    //     tr:nth-child(even)
    //         background: #F0F0F0
    //     tr:nth-child(odd)
    //         background: #E8E8E8
    // table
    //     width: 100%
    //     td
    //         padding: 4px


    // .label
    //     font-size: 14px
    //     p
    //         text-wrap: balance

.rule-type
    width: 340px

.panel
    background: #F0F0F0
    padding: 20px
    padding-top: 12px
    // border-radius: 4px
    // & + .panel
    //     margin-top: 20px
    &.odd
        background: #E8E8E8

.flex
    display: flex
    justify-content: space-between
    align-items: flex-end

.flex-row
    display: flex
    gap: 1rem
    .grow
        flex-grow: 1
</style>
